import apiService from './api.service';
import { unwrapApiResponse } from '@/utils/apiResponse';
import type {
  PublicSpinCampaign,
  PublicSpinResult,
  SpinEligibility,
} from '@/types/spinPlay.types';

class SpinPlayService {
  async listActiveCampaigns(): Promise<Array<{ id: string; name: string; slug: string; description: string | null }>> {
    const response = await apiService.get('/spin/campaigns/active');
    return unwrapApiResponse(response);
  }

  async getCampaignBySlug(slug: string): Promise<PublicSpinCampaign> {
    const response = await apiService.get<PublicSpinCampaign>(`/spin/campaigns/${encodeURIComponent(slug)}`);
    return unwrapApiResponse(response);
  }

  async checkEligibility(slug: string, phoneNumber: string): Promise<SpinEligibility> {
    const response = await apiService.get<SpinEligibility>(
      `/spin/campaigns/${encodeURIComponent(slug)}/eligibility`,
      { params: { phoneNumber } }
    );
    return unwrapApiResponse(response);
  }

  async spin(slug: string, phoneNumber: string): Promise<PublicSpinResult> {
    const response = await apiService.post<PublicSpinResult>(
      `/spin/campaigns/${encodeURIComponent(slug)}/spin`,
      { phoneNumber }
    );
    return unwrapApiResponse(response);
  }

  async getVoucherByCode(code: string) {
    const response = await apiService.get(`/spin/vouchers/${encodeURIComponent(code)}`);
    return unwrapApiResponse(response);
  }

  async previewVoucher(code: string) {
    const response = await apiService.get(`/spin/vouchers/${encodeURIComponent(code)}/preview`);
    return unwrapApiResponse(response) as {
      code: string;
      status: string;
      validFrom: string;
      validUntil: string;
      phoneNumber: string;
      offer: {
        id: string;
        title: string;
        discountPercentage?: number | null;
        discountAmount?: number | null;
      };
      campaign: { id: string; name: string; slug: string };
      segment: { id: string; label: string };
      canRedeem: boolean;
      reason?: string;
    };
  }
}

const spinPlayService = new SpinPlayService();
export default spinPlayService;
